import { render, staticRenderFns } from "./FormBuilderCanvas.vue?vue&type=template&id=03ac9e9c&scoped=true"
import script from "./FormBuilderCanvas.vue?vue&type=script&lang=js"
export * from "./FormBuilderCanvas.vue?vue&type=script&lang=js"
import style0 from "./FormBuilderCanvas.vue?vue&type=style&index=0&id=03ac9e9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ac9e9c",
  null
  
)

export default component.exports